import { getParamsUrl } from '@/helpers/request'
import Repository from './Repository'

const action = 'pages/landing'

export default {
  getListBid(settings = {}) {
    return Repository.get(action + getParamsUrl(settings))
  },
}
